import { useRouter } from "next/router";
import { useState }  from "react";

import { storeEvent }                            from "_analytics/index";
import { useGetAppLocale, useGetIsFollowStatus } from "_common/hooks/global";
import { getBaseURL, isPageRoute }               from "_common/utils";

import Presentation from "./presentation";

const component = props => {
	const { id, sessionDataId }                     = props;
	const [ isFollowAllHosts, setIsFollowAllHosts ] = useState ( false );
	const [ anchorEl, setAnchorEl ]                 = useState ( null );
	const [ open, setOpen ]                         = useState ( false );
	const followToggleDispatchState                 = useGetIsFollowStatus ();
	const userId                                    = id;

	const profileLink = `/profile/${ userId }`;
	const appLocale   = useGetAppLocale ();

	const router = useRouter ();

	const checkPageRoute = page => {
		return isPageRoute ( { router, page } );
	};

	const handleClickOpen = event => {
		if ( !open ) {
			setAnchorEl ( event.currentTarget );
			setOpen ( previousOpen => !previousOpen );
		}
	};

	const handleClickAway = () => {
		setOpen ( false );
	};

	const getSrc = () => {
		const baseURL = getBaseURL ();
		let shareLink = `${ baseURL }/stream/${ sessionDataId }`;

		return shareLink;
	};

	const handleFollowAllStatus = toggle => {
		setIsFollowAllHosts ( toggle );
	};

	const handleFollowGAEvent = type => {
		if ( checkPageRoute ( "video" ) )
			storeEvent ( "Profile", type, "Video" );

		if ( checkPageRoute ( "stream" ) )
			storeEvent ( "Profile", type, "Broadcast" );
	};

	return (
		<Presentation
			{ ...props }
			anchorEl              = { anchorEl }
			appLocale             = { appLocale }
			followProfile         = { followToggleDispatchState ? followToggleDispatchState : props?.isFollowingUser }
			getSrc                = { getSrc }
			handleClickAway       = { handleClickAway }
			handleClickOpen       = { handleClickOpen }
			handleFollowAllStatus = { handleFollowAllStatus }
			handleFollowGAEvent   = { handleFollowGAEvent }
			isFollowAllHosts      = { isFollowAllHosts }
			noOfFollowers         = { props?.followersCount }
			open                  = { open }
			profileLink           = { profileLink }
		/>
	);
};

export default component;
